'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('./index.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _pricingLevel = require('../pricing-level');

var _pricingLevel2 = _interopRequireDefault(_pricingLevel);

var _corporatePricingLevel = require('../corporate-pricing-level');

var _corporatePricingLevel2 = _interopRequireDefault(_corporatePricingLevel);

var _arrow = require('../arrow');

var _arrow2 = _interopRequireDefault(_arrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PricingLevels = function (_React$Component) {
    _inherits(PricingLevels, _React$Component);

    function PricingLevels(props) {
        _classCallCheck(this, PricingLevels);

        var _this = _possibleConstructorReturn(this, (PricingLevels.__proto__ || Object.getPrototypeOf(PricingLevels)).call(this, props));

        _this.shouldBeCarousel = function () {
            return _this.props.billingPlans.length;
        };

        _this.shouldRenderLevel = function (level) {
            return level && level.name && level.is_displayed == 'true';
        };

        _this.validBillingPlans = function () {
            return _this.props.billingPlans.filter(_this.shouldRenderLevel);
        };

        _this.rows = function () {
            return _this.validBillingPlans().map(pricingLevel.bind(_this, _this.props)).reduce(function (previousValue, currentValue) {
                var lastRow = previousValue[previousValue.length - 1];
                if (lastRow && lastRow.length < 3) {
                    lastRow.push(currentValue);
                    previousValue[previousValue.lenth - 1] = lastRow;
                    return previousValue;
                } else {
                    previousValue.push([currentValue]);
                    return previousValue;
                }
            }, []).map(function (row, index) {
                return _react2['default'].createElement(
                    'div',
                    { className: 'row', key: index },
                    row
                );
            });
        };

        _this.handleClick = function () {
            var nextIndex = (_this.state.currentRowIndex + 1) % _this.rows().length;
            _this.setState({ currentRowIndex: nextIndex });
        };

        _this.shouldRenderArrow = function () {
            return _this.rows().length > 1;
        };

        _this.state = {
            currentRowIndex: 0
        };
        return _this;
    }

    _createClass(PricingLevels, [{
        key: 'render',
        value: function render() {
            var currentRow = this.rows()[this.state.currentRowIndex];
            var animationDirection = this.state.currentRowIndex === 1 ? 'left' : 'right';
            var arrow = _react2['default'].createElement(_arrow2['default'], { handleClick: this.handleClick, direction: animationDirection });
            var totalColumns = this.props.billingPlans.length;
            var className = (0, _classnames2['default'])(_defineProperty({
                'm-pricing-level': true,
                'large-9': totalColumns >= 3,
                'large-8': totalColumns == 2,
                'large-6': totalColumns == 1,
                'columns': true
            }, 'pricing-animation-' + animationDirection, true));
            var wrapperStyle = {
                overflow: 'hidden',
                position: 'relative',
                paddingTop: 60
            };
            return _react2['default'].createElement(
                'div',
                null,
                _react2['default'].createElement(
                    'div',
                    { className: className, style: wrapperStyle },
                    _react2['default'].createElement(
                        _reactAddonsCssTransitionGroup2['default'],
                        { transitionName: 'pricing-row',
                            transitionEnterTimeout: 240,
                            transitionLeaveTimeout: 240 },
                        currentRow
                    )
                ),
                this.shouldRenderArrow() ? arrow : null,
                corporatePricingLevel(this.props)
            );
        }
    }]);

    return PricingLevels;
}(_react2['default'].Component);

PricingLevels.propTypes = {
    billingPlans: _react.PropTypes.array.isRequired
};


function pricingLevel(props, level, i) {
    // TODO:  Refactor PricingLevel so all you need to is pass "level" to
    // "PricingLevel" and let "PricingLevel" figure out all these props. In
    // other words, don't tell "PricingLevel" what it needs. "PricingLevel"
    // should be the one that know's what it needs. (FR)
    return _react2['default'].createElement(_pricingLevel2['default'], { key: i,
        isEventbrite: props.pricingSource === 'eventbrite',
        totalColumns: props.billingPlans.length,
        signupUrl: props.signupUrl,
        cardHolderName: props.cardHolderName,
        errors: props.errors,
        paymentForm: props.paymentForm,
        signupForm: props.signupForm,
        mustContactSales: props.mustContactSales,
        isAdmin: props.isAdmin,
        isDelinquent: props.isDelinquent,
        timePeriod: props.timePeriod,
        name: level.name,
        isApi: level.is_api,
        isUpgrade: level.is_upgrade,
        mainFeature: level.main_feature,
        features: level.features,
        monthlyPrice: level.monthly_price,
        annualPrice: (level.annual_price / 12).toFixed(0),
        monthlyCouponPrice: level.coupon_monthly_price && level.coupon_monthly_price.toFixed(0),
        annualCouponPrice: level.coupon_annual_price && (level.coupon_annual_price / 12).toFixed(0),
        price: props.isMonthly ? level.monthly_price : (level.annual_price / 12).toFixed(0),
        couponPrice: props.isMonthly ? level.coupon_monthly_price && level.coupon_monthly_price.toFixed(0) : level.coupon_annual_price && (level.coupon_annual_price / 12).toFixed(0),
        monthlyExpectedRate: level.monthly_expected_rate,
        annualExpectedRate: level.annual_expected_rate,
        monthlyProratedRate: level.monthly_prorated_rate,
        annualProratedRate: level.annual_prorated_rate,
        maxSeats: level.max_seats,
        mostPopular: level.is_api && i == 1,
        coupon: props.hasValidCoupon,
        couponCode: props.hasValidCoupon ? level.coupon_code : null,
        isFreeTrialEligible: level.is_free_trial_eligible,
        numFreeDays: level.num_free_days,
        isTrialing: level.is_trialing,
        proratio: level.proratio,
        planId: level.plan_id,
        isDisplayed: level.is_displayed,
        googleOpenIdUrlAnnual: level.google_open_id_url_annual,
        googleOpenIdUrlMonthly: level.google_open_id_url_monthly,
        ccSuffix: level.cc_suffix,
        ccExpiration: level.cc_expiration,
        isCurrentPlan: level.current_plan == level.plan_id,
        ApiPendingCancel: level.api_pending_cancel,
        UiPendingCancel: level.ui_pending_cancel,
        currentMonthlyRate: level.current_monthly_rate,
        currentAnnualRate: level.current_annual_rate,
        currentPlanName: props.pricingData.current_plan_name,
        isLoggedIn: level.is_logged_in,
        acctModalError: level.acct_modal_error,
        wasSelectedBeforeLogIn: level.is_logged_in && level.was_selected_before_login
    });
}

function corporatePricingLevel(props) {
    return _react2['default'].createElement(_corporatePricingLevel2['default'], { key: 'corporate',
        isApi: props.isApi,
        pricingSource: props.pricingSource,
        coupon: props.coupon,
        corporateFeatures: props.corporateFeatures,
        timePeriod: props.timePeriod,
        totalColumns: props.billingPlans.length,
        corpLevelName: props.corpLevelName
    });
}

module.exports = PricingLevels;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/pricing-levels/index.jsx
 ** module id = 1049
 ** module chunks = 0
 **/